import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const ChevronUp = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M6.46967 13.4697C6.17678 13.7626 6.17678 14.2374 6.46967 14.5303C6.76256 14.8232 7.23744 14.8232 7.53033 14.5303L6.46967 13.4697ZM12 9L12.5303 8.46967C12.2374 8.17678 11.7626 8.17678 11.4697 8.46967L12 9ZM16.4697 14.5303C16.7626 14.8232 17.2374 14.8232 17.5303 14.5303C17.8232 14.2374 17.8232 13.7626 17.5303 13.4697L16.4697 14.5303ZM7.53033 14.5303L12.5303 9.53033L11.4697 8.46967L6.46967 13.4697L7.53033 14.5303ZM11.4697 9.53033L16.4697 14.5303L17.5303 13.4697L12.5303 8.46967L11.4697 9.53033Z"
      fill="currentColor"
    />
  </Icon>
);

export default ChevronUp;
